import home from './home/routes';
import japan from './japan/routes';

export default [home, japan];
